export type RoleId = '00' | '01' | '02' | '03';

export interface RoleCapabilities {
  view: boolean;
  bid: boolean;
  load: boolean;
  manage: boolean;
}

// 00 viewer, 01 buyer, 02 loader, 03 manager
export const ROLE_CAPABILITIES: Record<RoleId, RoleCapabilities> = {
  '00': { view: true, bid: false, load: false, manage: false },
  '01': { view: true, bid: true, load: false, manage: false },
  '02': { view: true, bid: true, load: true, manage: false },
  '03': { view: true, bid: true, load: true, manage: true },
};

export function isRoleId(value: string | null): value is RoleId {
  return value === '00' || value === '01' || value === '02' || value === '03';
}
